export class BaseLayout {
    options;
    context;
    constructor(context, options) {
        this.context = context;
        this.options = options || {};
    }
    stop;
    tick;
}
//# sourceMappingURL=base-layout.js.map